import React from "react";

function Offcanvasorigin() {
  return <div>Offcanvasorigin</div>;
}

export default Offcanvasorigin;
